import Icon from "@ant-design/icons";

const PartiallyFurnishedSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1360 3680 l0 -240 560 0 560 0 0 -1280 0 -1280 -280 0 -280 0 0 -80
0 -80 640 0 640 0 0 80 0 80 -280 0 -280 0 0 1280 0 1280 560 0 560 0 0 240 0
240 -1200 0 -1200 0 0 -240z m2240 0 l0 -80 -1040 0 -1040 0 0 80 0 80 1040 0
1040 0 0 -80z"
      />
      <path
        d="M359 3812 c-63 -33 -109 -97 -116 -164 -7 -57 120 -633 153 -699 24
-48 65 -89 115 -115 16 -8 29 -21 29 -28 0 -8 -67 -350 -150 -760 l-150 -746
0 -290 0 -290 80 0 80 0 1 288 0 287 48 230 48 230 471 3 472 2 0 -520 0 -520
80 0 80 0 0 520 0 520 120 0 120 0 0 80 0 80 -120 0 -120 0 0 444 0 443 49 30
c94 59 136 185 97 288 -21 55 -98 127 -154 143 -27 8 -153 12 -410 12 l-372 0
-5 23 c-2 12 -16 85 -30 162 -35 192 -48 226 -104 284 -88 90 -212 115 -312
63z m172 -155 c19 -12 41 -36 49 -53 9 -17 33 -133 55 -257 l39 -227 429 0
c438 0 455 -1 484 -39 20 -27 15 -70 -12 -97 l-25 -25 -480 3 -480 3 -30 31
c-29 28 -35 50 -95 320 -36 159 -65 297 -65 307 0 26 37 57 69 57 15 0 43 -10
62 -23z m909 -1297 l0 -440 -456 0 c-430 0 -456 1 -452 18 3 9 42 207 89 440
l84 422 367 0 368 0 0 -440z"
      />
      <path
        d="M4555 3820 c-27 -11 -67 -34 -88 -51 -66 -55 -85 -101 -123 -301 -19
-101 -34 -184 -34 -185 0 -2 -167 -3 -371 -3 -258 0 -384 -4 -411 -12 -56 -16
-133 -88 -154 -143 -39 -103 3 -229 97 -288 l49 -30 0 -443 0 -444 -120 0
-120 0 0 -80 0 -80 120 0 120 0 0 -520 0 -520 80 0 80 0 0 520 0 520 472 -2
472 -3 48 -235 47 -235 1 -282 0 -283 80 0 80 0 0 283 0 282 -150 750 c-82
412 -150 757 -150 765 0 9 16 24 36 35 51 27 110 98 128 153 8 26 43 173 77
327 69 314 70 345 23 422 -57 93 -176 126 -289 83z m145 -160 c11 -11 20 -28
20 -38 0 -10 -29 -148 -65 -307 -60 -267 -68 -292 -95 -320 l-30 -30 -480 -3
-480 -3 -25 25 c-27 27 -32 70 -12 97 29 38 46 39 486 39 237 0 431 3 431 8 0
40 85 472 96 490 20 31 73 62 107 62 15 0 36 -9 47 -20z m-204 -1270 c46 -223
85 -420 89 -437 l6 -33 -456 0 -455 0 0 440 0 440 367 -2 367 -3 82 -405z"
      />
    </g>
  </svg>
);

const PartiallyFurnishedIcon = (props) => (
  <Icon component={PartiallyFurnishedSvg} {...props} />
);

export default PartiallyFurnishedIcon;
